import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import QuoteGenerator from "./components/QuoteGenerator";
import { Toaster } from "./components/ui/toaster";

// Composant pour l'avertissement rotation mobile
const RotateDeviceOverlay = () => {
  return (
    <div className="rotate-device-overlay">
      <div className="rotate-device-content">
        <div className="rotate-logo">
          <img 
            src="/logo-192.png" 
            alt="ToK'anD Logo" 
            className="rotating-logo"
          />
        </div>
        <h2>Veuillez tourner votre téléphone</h2>
        <p>Pour une meilleure expérience, utilisez ToK'anD en mode paysage</p>
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <RotateDeviceOverlay />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<QuoteGenerator />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;